import { render, staticRenderFns } from "./OlympiadRegisterBlock.vue?vue&type=template&id=df603a9e&scoped=true&"
import script from "./OlympiadRegisterBlock.vue?vue&type=script&lang=js&"
export * from "./OlympiadRegisterBlock.vue?vue&type=script&lang=js&"
import style0 from "./OlympiadRegisterBlock.vue?vue&type=style&index=0&id=df603a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df603a9e",
  null
  
)

export default component.exports